import { Action } from '@ngrx/store';

export enum AuthActionTypes {
  LoadAuth = '[Auth] Load Auth',
  AuthLoaded = '[Auth] Auth Loaded',
  AuthLoadError = '[Auth] Auth Load Error',
  SignIn = '[Auth] Sign In',
  SignInError = '[Auth] Sign In Error',
  SignedIn = '[Auth] Signed In',
  SignUp = '[Auth] Sign Up',
  SignUpError = '[Auth] Sign Up Error',
  SignedUp = '[Auth] Signed Up',
  LogOut = '[Auth] Log Out',
  LoggedOut = '[Auth] Logged Out',
  LogOutError = '[Auth] Log Out Error',
}

export class LoadAuth implements Action {
  readonly type = AuthActionTypes.LoadAuth;
}

export class AuthLoadError implements Action {
  readonly type = AuthActionTypes.AuthLoadError;
  constructor(public payload: any) {}
}

export class AuthLoaded implements Action {
  readonly type = AuthActionTypes.AuthLoaded;
  constructor(public payload: any) {}
}

export class SignIn implements Action {
  readonly type = AuthActionTypes.SignIn;
  constructor(public payload: { username: string; password: string }) {}
}

export class SignInError implements Action {
  readonly type = AuthActionTypes.SignInError;
  constructor(public payload: any) {}
}

export class SignedIn implements Action {
  readonly type = AuthActionTypes.SignedIn;
  constructor(public payload: any) {}
}

export class SignUp implements Action {
  readonly type = AuthActionTypes.SignUp;
  constructor(
    public payload: {
      username: string;
      password: string;
      email: string;
      role: string;
    }
  ) {}
}

export class SignUpError implements Action {
  readonly type = AuthActionTypes.SignUpError;
  constructor(public payload: any) {}
}

export class SignedUp implements Action {
  readonly type = AuthActionTypes.SignedUp;
  constructor(public payload?: any) {}
}

export class LogOut implements Action {
  readonly type = AuthActionTypes.LogOut;
}

export class LoggedOut implements Action {
  readonly type = AuthActionTypes.LoggedOut;
}

export class LogOutError implements Action {
  readonly type = AuthActionTypes.LogOutError;
  constructor(public payload?: any) {}
}

export type AuthAction =
  | LoadAuth
  | AuthLoaded
  | AuthLoadError
  | SignIn
  | SignInError
  | SignedIn
  | SignUp
  | SignUpError
  | SignedUp
  | LogOut
  | LoggedOut
  | LogOutError;

export const fromAuthActions = {
  LoadAuth,
  AuthLoaded,
  AuthLoadError,
  SignIn,
  SignInError,
  SignedIn,
  SignUp,
  SignUpError,
  SignedUp,
  LogOut,
  LoggedOut,
  LogOutError,
};
